import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../hooks";
import { LANG } from "../../i18n";
import { POLICY_BASE_URL } from "@/utils/env";
import close from "./assets/icon-close.svg";
import "./bottom.scss";
export const BottomText = () => {
  const [isShowIframe, setIsShowIframe] = useState(false);
  const { i18n, t } = useTranslation();
  const sysLanguage = useLanguage();
  const language = i18n?.language === "system" ? sysLanguage : i18n?.language;
  const [showType, setShowType] = useState(1);
  let lans = 1;
  lans = language === LANG.enUS ? 3 : language === LANG.zhCN ? 1 : 2;
  const policyHandler = () => {
    setShowType(1);
    setIsShowIframe(true);
  };
  const serveHandler = () => {
    setShowType(2);
    setIsShowIframe(true);
  };
  const hideIframeHandler = () => {
    setIsShowIframe(false);
  };
  /*
    showType:2 服务协议 1 隐私协议
    lans: 1 简体中文 2 繁体中文 3 英文
  */
  return (
    <>
      {isShowIframe && (
        <div className="iframe-container" onClick={hideIframeHandler}>
          <img src={close} className="close" />
          <iframe
            onClick={() => false}
            src={`${POLICY_BASE_URL}/?showType=${showType}&lan=${lans}#/`}
          />
        </div>
      )}
      <div className="bottom-text-container">
        {t("开始使用")}
        {t("即表示您同意")}
        <span onClick={serveHandler}>《{t("服务协议")}》</span>
        {t("和")}
        <span onClick={policyHandler}>《{t("隐私政策")}》</span>
        <div>{t("由运营方独立部署运营")}</div>
      </div>
    </>
  );
};
